export const DAO_CODE = 'FILE' + '_DAO';